import React from 'react';
import model1Image from '../@models/assets/model1.png'
import model2Image from '../@models/assets/model2.jpg'
import model3Image from '../@models/assets/model3.jpg'
import model4Image from '../@models/assets/model4.jpg'

const models = [
  {
    name: 'China TIMES 2.0',
    description: '中国TIMES能源系统优化模型2.0版本是一个技术丰富的能源系统优化模型，包含了从一次能源供应到终端能源服务需求的完整能源链条...',
    image: model1Image,
    details: '/models/china-times-v2'
  },
  {
    name: 'China TIMES-30P', 
    description: '中国TIMES 30省区市模型是在China TIMES模型基础上开发的省级能源系统优化模型，包含了中国30个省级行政区的详细能源系统...',
    image: model2Image,
    details: '/models/china-times-30p'
  },
  {
    name: 'Global TIMES',
    description: '全球TIMES模型是一个多区域全球能源系统优化模型，用于分析全球能源和气候政策...',
    image: model3Image,
    details: '/models/global-times'
  },
  {
    name: 'China CCUS DSS 2.0',
    description: '中国CCUS决策支持系统2.0是一个CO2源汇匹配模型，用于支持全国尺度CCUS布局规划...',
    image: model4Image,
    details: '/models/china-ccus-dss'
  }
];

export default function Models() {
  return (
    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">模型介绍</h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
          </p>
        </div>
        <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-8 sm:mt-16 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          {models.map((model) => (
            <div key={model.name} className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-full h-48 flex items-center justify-center bg-gray-50 rounded-lg mb-4">
                <img 
                  src={model.image} 
                  alt={model.name} 
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">{model.name}</h3>
              <p className="mt-2 text-gray-600">{model.description}</p>
              <div className="mt-4">
                <a 
                  href={model.details} 
                  className="text-sm text-indigo-600 hover:text-indigo-500"
                >
                  了解更多 →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}